import React from "react";
import { FaEdit, FaPhoneAlt, FaPlusCircle, FaTrash, FaList, FaLock, FaLockOpen, FaMapMarkerAlt, FaMapSigns } from "react-icons/fa";
import { MdDownload, MdPassword, MdSms } from "react-icons/md";
import { RiUserAddFill } from "react-icons/ri";
import { LuMessageCircleWarning } from "react-icons/lu";
import { IoIosWarning } from "react-icons/io";
import formatCustomDateWithTime from "../helpers/customDateFormatWithTime";

const EventDetailsCard = ({
  eventDetails,
  onClick,
  onEdit,
  onDelete,
  onManageVillages,
  onManageDuplicates,
  cardStyle,
  onCredShow,
  onAddOperator,
  onDownloadReport,
  onCloseEvent,
  onRequestReopen,
  errorinfo,
  reminderCall,
  reminderSms,
  confirmationSms,
  addServices,
  tokenCount,
  makePayment,
  total_reminder_list,
  old_entry,
  onDeleteVoiceCall,
  onDeleteSms,
  onDeleteConfirmationSms,
  onOperatorTotalsShow,
}) => {
  const {
    event_date,
    event_type,
    customer_name,
    customer_mobile,
    registered_on,
    created_at,
    eventor_1,
    eventor_2,
    event_id,
    total_moi_amount,
    operator_totals,
  } = eventDetails;
  const createdOn = created_at || registered_on;
  const eventors = [eventor_1, eventor_2].filter(Boolean).join(", ");
  const isPaid =
    eventDetails.razorpay_payment_id && eventDetails.razorpay_order_id;
  const needsPayment = makePayment && !isPaid;

  return (
    <div
      onClick={() => onClick(eventDetails)}
      style={{
        background: "#ffffff",
        border: needsPayment
          ? "1.5px solid rgba(239,68,68,0.4)"
          : "1.5px solid rgba(20,184,166,0.18)",
        boxShadow: needsPayment
          ? "0 8px 32px rgba(239,68,68,0.08), 0 4px 12px rgba(0,0,0,0.03)"
          : "0 8px 32px rgba(0,0,0,0.04), 0 2px 8px rgba(0,0,0,0.02)",
        borderLeft: needsPayment ? "3px solid #ef4444" : "3px solid #14b8a6",
        transition: "all 0.25s cubic-bezier(0.4,0,0.2,1)",
      }}
      className="group relative w-full cursor-pointer overflow-hidden rounded-2xl transition-all hover:translate-y-[-2px] hover:shadow-lg"
    >
      <div
        style={{
          background: needsPayment
            ? "linear-gradient(90deg, #ef4444, transparent)"
            : "linear-gradient(90deg, #14b8a6, #0ea5e9, transparent)",
        }}
        className="h-0.5 w-full"
      />

      <div className="p-4">
        {needsPayment ? (
          <div className="mb-3 flex items-center gap-2 rounded-xl border border-red-500/30 bg-red-500/15 px-3 py-2">
            <IoIosWarning className="shrink-0 text-lg text-red-400" />
            <p className="text-xs font-bold uppercase tracking-wide text-red-500">
              Payment Required
            </p>
          </div>
        ) : (
          <div className="mb-3 flex items-center justify-between">
            {errorinfo ? (
              <span className="inline-flex items-center gap-1 rounded-full border border-red-100 bg-red-50 px-2.5 py-1 text-xs font-bold text-red-600">
                Warning {errorinfo}
              </span>
            ) : (
              <div />
            )}

            <div className="flex items-center gap-1.5">
              {onDownloadReport && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onDownloadReport(eventDetails.event_id);
                  }}
                  title="Download Overall Report"
                  color="indigo"
                  icon={<MdDownload />}
                />
              )}
              {onCloseEvent && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onCloseEvent(eventDetails.event_id);
                  }}
                  title="Close Event"
                  color="blue"
                  icon={<FaLock />}
                />
              )}
              {onRequestReopen && (
                eventDetails.reopen_requested === 1 || eventDetails.reopen_requested === "1" ? (
                   <span className="text-xs font-semibold text-orange-600 bg-orange-100 px-2 py-1 rounded-md">
                     Re-open Requested
                   </span>
                ) : (
                  <ActionBtn
                    onClick={(e) => {
                      e.stopPropagation();
                      onRequestReopen(eventDetails.event_id);
                    }}
                    title="Request Re-open"
                    color="orange"
                    icon={<FaLockOpen />}
                  />
                )
              )}
              {onCredShow && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onCredShow(eventDetails.event_id);
                  }}
                  title="View Operators & Passwords"
                  color="teal"
                  icon={<MdPassword />}
                />
              )}
              {onOperatorTotalsShow && operator_totals && operator_totals.length > 0 && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onOperatorTotalsShow(eventDetails);
                  }}
                  title="View Operator Totals"
                  color="purple"
                  icon={<FaList />}
                />
              )}
              {onAddOperator && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onAddOperator(eventDetails.event_id);
                  }}
                  title="Add Operators"
                  color="green"
                  icon={<RiUserAddFill />}
                />
              )}
              {onManageVillages && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onManageVillages(eventDetails.event_id);
                  }}
                  title="Manage Villages"
                  color="indigo"
                  icon={<FaMapSigns />}
                />
              )}
              {onEdit && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onEdit(eventDetails);
                  }}
                  title="Edit Details"
                  color="yellow"
                  icon={<FaEdit />}
                />
              )}
              {onDelete && (
                <ActionBtn
                  onClick={(e) => {
                    e.stopPropagation();
                    onDelete(eventDetails);
                  }}
                  title="Cancel Event"
                  color="red"
                  icon={<FaTrash />}
                />
              )}
            </div>
          </div>
        )}

        <div className="mb-3">
          <p className="mb-0.5 text-xs font-bold uppercase tracking-widest text-teal-700">
            Event
          </p>
          <div className="flex flex-col gap-1">
            <h3 className="text-base font-black leading-tight text-gray-900">
              {event_type}
            </h3>
            {event_id ? (
              <span className="text-xs font-semibold uppercase tracking-wide text-gray-500">
                Event ID #{event_id}
              </span>
            ) : null}
          </div>
        </div>

        <div className="space-y-2">
          <InfoRow label="Customer" value={customer_name} />
          <InfoRow label="Customer Mobile" value={customer_mobile || "-"} />
          <InfoRow label="Eventors" value={eventors || "—"} />
          <InfoRow
            label="Event Date"
            value={formatCustomDateWithTime(event_date)}
          />
          <InfoRow
            label="Created On"
            value={createdOn ? formatCustomDateWithTime(createdOn) : "—"}
          />
          <InfoRow 
            label="Total Moi Amount" 
            value={total_moi_amount != null ? `₹ ${total_moi_amount}` : "—"} 
          />

          {!old_entry && (
            <>
              <div className="flex items-center justify-between py-0.5">
                <span className="text-xs font-semibold text-gray-400">
                  Tokens
                </span>
                <span
                  style={{
                    background: "rgba(20,184,166,0.1)",
                    border: "1px solid rgba(20,184,166,0.2)",
                  }}
                  className="rounded-full px-2 py-0.5 text-xs font-black text-teal-700"
                >
                  {tokenCount || "--"}
                </span>
              </div>
              <div className="flex items-center justify-between py-0.5">
                <span className="text-xs font-semibold text-gray-400">
                  Reminder List
                </span>
                <span
                  style={{
                    background: "rgba(14,165,233,0.1)",
                    border: "1px solid rgba(14,165,233,0.2)",
                  }}
                  className="rounded-full px-2 py-0.5 text-xs font-black text-sky-700"
                >
                  {total_reminder_list || "--"}
                </span>
              </div>

              {(Number(reminderCall) > 0 ||
                Number(reminderSms) > 0 ||
                Number(confirmationSms) > 0 ||
                addServices) &&
                isPaid && (
                  <div className="flex items-center justify-between pt-1">
                    <span className="text-xs font-semibold text-gray-400">
                      Services
                    </span>
                    <div className="flex items-center gap-2">
                      {Number(reminderCall) > 0 && (
                        <ServiceIcon
                          icon={<FaPhoneAlt />}
                          label="Reminder Call"
                          color="emerald"
                          onDelete={onDeleteVoiceCall ? (e) => { e.stopPropagation(); onDeleteVoiceCall(); } : null}
                        />
                      )}
                      {Number(reminderSms) > 0 && (
                        <ServiceIcon
                          icon={<LuMessageCircleWarning />}
                          label="Reminder SMS"
                          color="amber"
                          onDelete={onDeleteSms ? (e) => { e.stopPropagation(); onDeleteSms(); } : null}
                        />
                      )}
                      {Number(confirmationSms) > 0 && (
                        <ServiceIcon
                          icon={<MdSms />}
                          label="Confirmation SMS"
                          color="teal"
                          onDelete={onDeleteConfirmationSms ? (e) => { e.stopPropagation(); onDeleteConfirmationSms(); } : null}
                        />
                      )}
                      {addServices && (
                        <button
                          onClick={(e) => {
                            e.stopPropagation();
                            addServices();
                          }}
                          style={{
                            background: "rgba(20,184,166,0.1)",
                            border: "1px solid rgba(20,184,166,0.3)",
                          }}
                          className="flex h-6 w-6 items-center justify-center rounded-full transition hover:bg-teal-500/20"
                          title="Add Services"
                        >
                          <FaPlusCircle className="text-xs text-teal-500" />
                        </button>
                      )}
                    </div>
                  </div>
                )}
            </>
          )}
        </div>

        {onManageDuplicates && !eventDetails.result_file && (
          <button type="button" onClick={(e) => {
            e.stopPropagation();
            onManageDuplicates(eventDetails.event_id);
          }} title="Manage Duplicate Entries"
            className="mt-4 w-full rounded-xl border border-teal-200 bg-teal-50 px-3 py-2.5 text-sm font-bold text-teal-800 transition hover:bg-teal-100 focus:outline-none focus:ring-2 focus:ring-teal-600">
            Manage Duplicate Entries
          </button>
        )}

        {needsPayment && (
          <div className="mt-4">
            <button
              onClick={(e) => {
                e.stopPropagation();
                makePayment(eventDetails.event_id);
              }}
              style={{
                background:
                  "linear-gradient(135deg, #0f2742, #164e63 52%, #0f766e)",
                boxShadow: "0 4px 16px rgba(15,118,110,0.24)",
              }}
              className="w-full rounded-xl py-2.5 text-sm font-black tracking-wide text-white transition-all hover:opacity-90 active:scale-95"
            >
              Pay Now to Activate
            </button>
          </div>
        )}
      </div>

      <div
        style={{
          background: "linear-gradient(90deg, #14b8a6, #0ea5e9, transparent)",
          opacity: 0,
          transition: "opacity 0.3s ease",
        }}
        className="h-0.5 w-full group-hover:opacity-100"
      />
    </div>
  );
};

function ActionBtn({ onClick, title, color, icon }) {
  const COLORS = {
    blue: {
      bg: "rgba(14,165,233,0.12)",
      border: "rgba(14,165,233,0.25)",
      text: "#0369a1",
    },
    teal: {
      bg: "rgba(20,184,166,0.12)",
      border: "rgba(20,184,166,0.28)",
      text: "#0f766e",
    },
    indigo: {
      bg: "rgba(99,102,241,0.12)",
      border: "rgba(99,102,241,0.28)",
      text: "#4f46e5",
    },
    green: {
      bg: "rgba(34,197,94,0.15)",
      border: "rgba(34,197,94,0.35)",
      text: "#16a34a",
    },
    yellow: {
      bg: "rgba(234,179,8,0.15)",
      border: "rgba(234,179,8,0.35)",
      text: "#ca8a04",
    },
    red: {
      bg: "rgba(239,68,68,0.15)",
      border: "rgba(239,68,68,0.35)",
      text: "#dc2626",
    },
  };
  const c = COLORS[color] || COLORS.teal;

  return (
    <button
      onClick={onClick}
      title={title}
      style={{
        background: c.bg,
        border: `1px solid ${c.border}`,
        color: c.text,
      }}
      className="flex h-8 w-8 items-center justify-center rounded-xl text-sm shadow-sm transition-all hover:opacity-80 active:scale-90"
    >
      {icon}
    </button>
  );
}

function InfoRow({ label, value, valueClassName = "" }) {
  return (
    <div className="flex items-center justify-between py-0.5">
      <span className="text-xs font-semibold text-gray-400">{label}</span>
      <span
        className={`max-w-[55%] truncate text-right text-xs font-bold text-gray-700 ${valueClassName}`}
      >
        {value}
      </span>
    </div>
  );
}

function ServiceIcon({ icon, label, color, onDelete }) {
  const COLORS = {
    emerald: {
      bg: "rgba(52,211,153,0.15)",
      border: "rgba(52,211,153,0.3)",
      text: "#059669",
    },
    amber: {
      bg: "rgba(245,158,11,0.15)",
      border: "rgba(245,158,11,0.3)",
      text: "#d97706",
    },
    teal: {
      bg: "rgba(20,184,166,0.12)",
      border: "rgba(20,184,166,0.28)",
      text: "#0f766e",
    },
  };
  const c = COLORS[color] || COLORS.teal;

  return (
    <div className="relative group/icon">
      <div
        title={label}
        style={{
          background: c.bg,
          border: `1px solid ${c.border}`,
          color: c.text,
        }}
        className="flex h-6 w-6 items-center justify-center rounded-full text-xs shadow-sm"
      >
        {icon}
      </div>
      {onDelete && (
        <button
          onClick={onDelete}
          title={`Remove ${label}`}
          className="absolute -top-1.5 -right-1.5 h-3.5 w-3.5 rounded-full bg-red-500 text-white flex items-center justify-center text-[8px] font-bold shadow-sm opacity-0 group-hover/icon:opacity-100 transition-opacity hover:bg-red-600"
        >
          ✕
        </button>
      )}
    </div>
  );
}

export default EventDetailsCard;
